<template>
	<div id="team " class="page">
		<div class="teamnav">
			  <div v-for="item in teamList" v-on:click="event_switch(item)" hover-class="other-navigator-hover" v-bind:class="{cur:item.checked}">{{item.subject}}</div>
		  </div>
		  <div class="box page-infinite-wrapper " ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
			<div class="show"
				title="加载"
				v-infinite-scroll="loadData"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="50"
				infinite-scroll-immediate-check="false">
			  <div style="position:relative;padding:5px;">
				<input type="text" v-model="team.keyword" v-on:input="event_searchinput(team)" placeholder="请输入手机号码查询" style="width:90vw;height:30px;display:block;background-color:#FFFFFF;border:1px solid #DDDDDD;padding:0vw 2vw;border-radius:5px;"/>
				<div style="position:absolute;height:31px;width:80px;right:3vw;top:5px;background-color:#CCCCCC;text-align:center;line-height:30px;border-radius:0px 5px 5px 0px;z-index:10000;" v-on:click="event_search()">搜索</div>
			  </div>
			  <div class="team-info">
				<div class='team-list' v-for="user in team.userList">
					<div class='top' v-on:click="event_userdetail(user)">
					  <div class='team-left'>
						  <img v-bind:src="user.avatar"/>
					  </div>
					  <div class='team-right'>
						  <div class='nametop clearfix'>
							  <span class='name'>{{user.nickname}}</span>
							  <span style="float:right;">{{user.mobile}}</span>
						  </div>
						  <div class="clearfix"></div>
						  <div class='namebottom'>
							  <span class='joindate'>{{user.create_at}}加入</span>
							  <div class='renshu'>
								  <span style="display:block">总客户：{{user.childUserCount}}人</span>
								  <span style="display:block">成交客户：{{user.realUserCount}}人</span>
							  </div>
						  </div>
						  <div class='tuiguang-num'>
							<div class='pic' v-for="child in user.userList">
								<img v-bind:src="child.avatar"/>
							</div>
							<span v-if="user.userList.length">全部</span>
						  </div>
					  </div>
					</div>
					<div class='bottom'>
					  <div>消费：<span>{{user.total_fee}}</span> 元</div>
					  <div>收益：<span>{{user.withdraw}}</span> 元</div>
					  <div v-on:click="event_showorder(user)"><span>{{user.total_count}}</span> 个订单</div>
					</div>
				</div>
			  </div>
			</div>
			 <p v-show="loading" class="loading-tips" style="text-align:center;">
				<wv-spinner type="snake" color="#444" :size="24"/>
			</p>
		  </div>

	</div>
</template>

<script>
import { Toast , Dialog, InfiniteScroll} from 'we-vue'
let params = []
export default {
	data () {
		return {
			loaded:false,
			teamList:[],
			loading:false,
			page:1,
			user_id:0,
			searchData:[],
			wrapperHeight: 0,
			team:{}
		}
	},
	beforeRouteLeave(to, from, next){
		if(params.length){
			console.log(params[params.length-1])
			this.setData(params[params.length-1])
			params.length--;
			this.$wx.navigateTo({
				url: '/Team',
			})
		}else{
			next()
		}
	},
	mounted () {
		this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top
	},
	created () {
		this.loadLevel();
	},
	methods: {
		loadLevel(reset){
			if(reset){
				this.setData({
					loaded:false,
					teamList:[],
					loading:false,
					page:1,
					user_id:0,
					searchData:[],
					wrapperHeight: 0,
					team:{}
				})
			}
			try{
				this.user_id = this.$route.query.param.user_id;
			}catch(e){
				this.user_id = this.$store.state.userInfo.id
			}
			this.$https.post("/api/distribution/userlevel",this.$qs.stringify({
				token:this.$store.state.token,
				user_id:this.user_id,
				page:this.page
			})).then((res) => {
				for(var n in res.data.data){
					if(n == 0){
						res.data.data[n].checked = true
						this.team = res.data.data[n]
					}
					this.teamList.push(res.data.data[n])
				}
				this.loaded = true
				this.loadData();
				console.log(params)
				this.page++;
			}).catch(() => {

			});
		},
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		event_switch(item){
			var id = item.id;
			    for(var n in this.teamList){
			      if(this.teamList[n].id == id){
				this.teamList[n].checked = true;
				this.team = this.teamList[n]
			      }else{
				this.teamList[n].checked = false;
			      }
			    }
		},
		event_search(){
			this.$wx.showLoading({
				title: '正在搜索..',
			})
			this.team.page = 1;
			this.team.userList = [];
			this.searchData[this.team.id] = this.team.keyword;
			this.loadData();
		},
		event_searchinput(item){
		},
		getLevel:function(){
		    for(var n in this.teamList){
		      if(this.teamList[n].checked){
			return this.teamList[n];
		      }
		    }
		    return this.teamList[0];
		},
		loadData(){
			if(this.loaded){
				var level = this.getLevel();
				this.$https.post("/api/distribution/userlist",this.$qs.stringify({
					token:this.$store.state.token,
					page:level.page,
					user_id: this.user_id,
					level_id:level.id,
					mobile: this.searchData[level.id] ? this.searchData[level.id] : ''
				})).then((res) => {
					res.data = res.data.data;
					for(var n in this.teamList){
						if(this.teamList[n].id == level.id){
							for(var m in res.data){
								this.teamList[n].userList.push(res.data[m]);
							}
							if(res.data.length > 0){
								this.teamList[n].page += 1;
							}
						}
					}
					this.$nextTick(() => {
						this.loading = false
					});
					this.page++;
				}).catch(() => {

				});
			}
		},
		event_userdetail(item){
			this.$route.query.param = {
				user_id:item.id
			};
			let d = {
				loaded:false,
				teamList:[],
				loading:false,
				page:1,
				user_id:0,
				searchData:[],
				wrapperHeight: 0,
				team:{}
			}
			//把当前设置写入记录中
			for(var n in d){
				d[n] = this[n]
			}
			params.push(d)
			this.loadLevel(true);
		},
		event_showorder(item){
			this.$wx.navigateTo({
				url: '/Corder?user_id='+item.id,
			})
		}
	},
	filters: {

	}
}
</script>

<style scoped>
	#team{
		background-color:#ffffff;
		min-height:100vh;
	}
.teamnav{
  display: flex;
  background: #fff;
  height: 35px;
  border-bottom: 1px solid #dedede;
  line-height: 35px;
  position:fixed;
  left:0px;
  top:0px;
  width:100%;
  z-index:10000;
}
.hide{
  display:none;
}
.show{
  display:block;
}
.teamnav div{
    flex:1;
    text-align: center;
    font-size: 14px;
    margin: 0 10px;
    color: #898989;
}
.teamnav div.other-navigator-hover{
  border-bottom: 2px solid #2cd5ff;
}
.teamnav div.cur{
  border-bottom: 2px solid #2cd5ff;
}
.box{
  margin-top:35px;
}
.team-list{
  margin-bottom: 10px;
  background: #fff;
}
.team-list .top{
  display: flex;
  padding: 10px;
  align-items: center;
}
.team-list .top .team-left img{
  width:70px;
  height: 70px;
  margin-right: 10px;
  border-radius: 100%;
}
.team-list .top .team-right{
  border-bottom: 1px solid #ededed;
  padding-bottom: 15px;
  width:100%;

}
.nametop span{
  font-size: 14px;
  color: #999;
}
.nametop .name{
  font-size: 16px;
  color: #333;
  margin-right: 5px;
}
.namebottom{
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
}
.namebottom .joindate{
  color: #999;
}
.namebottom .renshu span{
  font-size: 14px;
  color: #2cd5ff;
}
.namebottom .renshu .icon-arrowdown{
  background:url(http://jk.ioccn.com/jiakao/arrow-down.png) no-repeat;
  width: 12px;
  height: 7px;
  display: inline-block;
}
.team-list .bottom{
  display: flex;
  padding: 0 10px 10px 10px;
  justify-content: space-between;
  color: #aaa;
  font-size:14px;
}
.team-list .bottom span{
  color: #000;
}
.tuiguang-num{
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.tuiguang-num img{
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-right: 5px;
}
.tuiguang-num span{
  font-size: 12px;
  color: #2cd5ff;
}

.clearfix{
  content:'';
  width:100%;
  height:1px;
  clear:both;
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue